export default "__VITE_ASSET__laPZjJu2__"